import React from "react";
import {useSelector, useDispatch} from "react-redux";
import styles from "./Facet.module.scss";

import {ACTIVATE_FACET_MULTI, DEACTIVATE_FACET_MULTI} from "../../Store/Actions/ActionTypes";
import { filterFacet } from "../../Utils/filterFacets";

const Facet = (props) => {
    const {value, count, facetName} = props;
    const dispatch = useDispatch();
    const newFilterState = useSelector(state => state.newFilterReducer);
    const activeFilters = newFilterState.activeFilters;

    let renderVal = value;

    // if (value === "OIB"){
    //     renderVal = "Opplæring i bedrift";
    // }
    

    // Filtering out some nivas ref utdtek-1371
    let subFacet = activeFilters.utdanningsniva ? activeFilters.utdanningsniva.value : null;
    // console.log("value", value);
    
    
    if(subFacet === "Universitet og høgskole"){
        if(!filterFacet(activeFilters.hovedfasett.value, facetName, subFacet, value)) {
            return null;
        }
    }
    
    // 


    let myClass = `${styles.wrapper}`;
    let isActive = false;
    if (activeFilters[facetName] !== undefined) {
        for (const item of activeFilters[facetName]) {
            if (item.value === value) {
                isActive = true;
                myClass += ` ${styles.active}`;
                break;
            }
        }
    }

    const handleClick = () => {
        const payload = {
            value: value,
            facetName: facetName
        };
        if (!isActive) {
            dispatch({type: ACTIVATE_FACET_MULTI, payload: payload});
        }
        else {
            dispatch({type: DEACTIVATE_FACET_MULTI, payload: payload});
        }
    };

    const handleKeyDown = (e) => {
        if (e.keyCode === 13) { // Handle enter
            e.target.click();
        }
    };

    return (
        <div tabIndex="0" className={myClass} onClick={handleClick} onKeyDown={handleKeyDown}>{renderVal} ({count})</div>
    )
};

export default Facet;